var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1639_23273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 32H235.556V235.556H32V32ZM32 286.444H235.556V490H32V286.444ZM286.444 32H490V235.556H286.444V32ZM286.444 286.444H490V490H286.444V286.444ZM337.333 82.8889V184.667H439.111V82.8889H337.333ZM337.333 337.333V439.111H439.111V337.333H337.333ZM82.8889 82.8889V184.667H184.667V82.8889H82.8889ZM82.8889 337.333V439.111H184.667V337.333H82.8889Z",
    fill: "#7CB900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1639_23273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetCategory);
export default __webpack_public_path__ + "static/media/AssetCategory.e3e6c50e420668d22e016c060ef4b4de.svg";
export { ForwardRef as ReactComponent };